// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"32e46d91","206":"089dec36","209":"db7c2e99","236":"ebcfa46c","308":"8c8cd46d","368":"2970817a","427":"ee95b139","457":"24f09ca7","551":"bff6370f","828":"d47f7df2","842":"37c19774","851":"ae0fc617"}[chunkId] + ".chunk.js";
};